import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contains',
  standalone: false,
})
export class ContainsPipe implements PipeTransform {
  public transform(value: string, searchString: string): boolean {
    return !!value && !!searchString && value.includes(searchString);
  }
}
